import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit-product-service',
  templateUrl: './edit-product-service.component.html',
  styleUrls: ['./edit-product-service.component.scss']
})
export class EditProductServiceComponent implements OnInit {
  @Input() productInfo: any;

  constructor(
    private activeModal: NgbActiveModal,
  ) {
  }

  ngOnInit(): void {
  }

  sendData(): any {
    const dataToSend = {...this.productInfo};
    this.activeModal.close(dataToSend);
  }

  createLinkFields() {
    this.productInfo.productServicesItem.push({
      item: '',
      url: '',
      orderId: this.productInfo.productServicesItem.length + 1,
      columnId: this.productInfo.column
    });
  }


  deleteLinkField(i: number): any {
    if (this.productInfo.productServicesItem.length > 1) {
      this.productInfo.productServicesItem.splice(i, 1);
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'No puedes eliminar el primer link!',
      });
    }
  }

  validateEmptyFields(): any {
    if (!this.productInfo.title ||
      this.productInfo.productServicesItem.filter(x => !x.item).length ||
      this.productInfo.productServicesItem.filter(x => !x.url).length
    ) {
      return false;
    } else {
      return true;
    }
  }

  checkExistingName(): any {
    const validators = [];
    this.productInfo.all.forEach(item => {
      item.detail.forEach(child => {
        validators.push(child.title);
      });
    });
    const checkExistingName = (arr, val) => {
      return arr.some(arrVal => {
        return val.toLowerCase().trim() === arrVal.toLowerCase().trim();
      });
    };
    const valueToRemove = validators.indexOf(this.productInfo.title);
    validators.splice(valueToRemove, 1);
    return checkExistingName(validators, this.productInfo.title);
  }
}
